import { fetchTemplates } from '@/api/v4/template.api';
import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';

export const useTemplates = () => {
  return useQuery({
    queryKey: [QueryKey.Templates],
    queryFn: fetchTemplates,
    staleTime: 1000 * 10 * 5,
  });
};
